export default __webpack_public_path__ + "assets/front/scss/editorial.ed0849a7cbdf2a68fdd00a4b0c375590.css";